import { StaircaseBack, StaircaseFront, StaircaseShade, StaircaseSheen } from './staircase.art';
import { staircaseRegions } from './staircase.geometry';
import type { SceneDefinition } from './types';

/** Staircase: seven treads and risers and the landing above them. */
export const staircaseScene: SceneDefinition = {
  id: 'staircase',
  surface: 'stairs',
  regions: staircaseRegions,
  Back: StaircaseBack,
  Shade: StaircaseShade,
  Sheen: StaircaseSheen,
  Front: StaircaseFront,
  seams: false,
  photo: null,
};
